import { t } from "../../utils/i18n";

export const typesMapping = () => ({
  "Trade": t("wallets.master_fees.type_trade"),
  "BcCryptoWithdrawal": t("wallets.master_fees.type_withdrawal_pol"),
  "BcCryptoEthWithdrawal": t("wallets.master_fees.type_withdrawal_eth"),
  "Payme": t("wallets.master_fees.type_payme"),
  "CardLoad": t("wallets.master_fees.type_card_load"),
  "CardRequest": t("wallets.master_fees.type_card_request")

});
